import type { ListingActivationResult } from '~/features/employer/billing/types';
import { JobListingDetailSummary } from '~/types/hlx/jobListingDetail';
import { deleteData, getData, postData } from '~/utils/service';
import { previewListingFee } from '../listingFee';
import { OnGetSummary, Scope } from './types';

const ROUTE_NAME = 'jobListing';
const ACTIVATE_ROUTE_NAME = 'jobListingActivate';
const DEACTIVATE_ROUTE_NAME = 'jobListingDeactivate';
const LISTING_SUMMARY_ROUTE_NAME = 'jobListingSummary';

export const API_CALLS = {
  get: async ({ input }: { input: Scope }) => {
    return await getData(ROUTE_NAME, {
      pathParams: { employerId: input.context.employerUser?.employerId?.toString() || '' },
    });
  },
  delete: async ({ input }: { input: Scope }) => {
    return await deleteData(ROUTE_NAME, {
      pathParams: { id: input.context.idToDelete.toString() },
    });
  },
};

export const activateListing = async ({ input }: { input: Scope }) => {
  return await postData<ListingActivationResult>(ACTIVATE_ROUTE_NAME, {
    pathParams: { id: input.context.listing?.id.toString() || '' },
  });
};

// [MCV-1933] What publishing this listing would cost; null when the preview could not be read.
export const previewActivationFee = async ({
  input,
  signal,
}: {
  input: Scope;
  signal?: AbortSignal;
}) => previewListingFee('job', input.context.listing?.id, signal);

export const deactivateListing = async ({ input }: { input: Scope }) => {
  return await postData(DEACTIVATE_ROUTE_NAME, {
    pathParams: { id: input.context.listing?.id.toString() || '' },
  });
};

export const getSummary = async ({
  input,
}: {
  input: Scope;
}): Promise<JobListingDetailSummary | undefined> => {
  const listing = (input.event as OnGetSummary).payload.listing;
  if (!listing) {
    return undefined;
  }
  return await postData(LISTING_SUMMARY_ROUTE_NAME, {
    data: listing,
  });
};
